import InfinityWayImage from "../../assets/images/projects/InfinityWay/InfinityWayImg.png"
import InfinityWayIcon from "../../assets/images/projects/InfinityWay/InfinityWayIcon.png"
import InfinityWayGif from "../../assets/images/projects/InfinityWay/InfinityWayGif.gif"

import blockBrakerGameImage from "../../assets/images/projects/blockBraker/blockBrakerGame.png"
import blockBrakerIcon from "../../assets/images/projects/blockBraker/Favicon.png"
import blockBrakerGif from "../../assets/images/projects/blockBraker/BlockBraker.gif"


import PongImage from "../../assets/images/projects/pong/pongImg.png"
import PongIcon from "../../assets/images/projects/pong/pongIcon.png"
import PongGif from "../../assets/images/projects/pong/pongGif.gif"

import FifbirdImage from "../../assets/images/projects/FiftBird/FiftbirdImage.png"
import FifbirdIcon from "../../assets/images/projects/FiftBird/FifityBirdIcon.png"
import FifbirdGif from "../../assets/images/projects/FiftBird/FiftbirdGif.gif"


import ProjectZeldaImage from "../../assets/images/projects/ZeldaProject/ZeldaProjectImg.png"
import ProjectZeldaIcon from "../../assets/images/projects/ZeldaProject/ProjectZeldaIcon.png"
import ProjectZeldaGif from "../../assets/images/projects/ZeldaProject/ZeldaProjectGif.gif"

import LandingPageDogAdventureImage from "../../assets/images/projects/landingPageDogAdventure/DogAdventure-Landing-Page-Img.png"
import LandingPageDogAdventureIcon from "../../assets/images/projects/landingPageDogAdventure/Vortex-logo.png"
import LandingPageDogAdventureGif from "../../assets/images/projects/landingPageDogAdventure/DogAdventure-Landing-Page-Gif.gif"


import RobotClawImage from "../../assets/images/projects/robotClaw/robotClawImg.png"
import RobotClawIcon from "../../assets/images/projects/robotClaw/robotClawIcon.png"
import RobotClawGif from "../../assets/images/projects/robotClaw/roboticClawGif.gif"

import EmissionCO2Image from "../../assets/images/projects/emissionCO2/emissãoCO2BrasilImg.png"
import EmissionCO2Icon from "../../assets/images/projects/emissionCO2/emissãoCO2BrasilIcon.png"
import EmissionCO2Gif from "../../assets/images/projects/emissionCO2/emissãoCO2BrasilGif.gif"

import ConnectDevelopersImage from "../../assets/images/projects/connectDevelopers/connectDevelopersImg.png"
import ConnectDevelopersIcon from "../../assets/images/projects/connectDevelopers/connectDevelopersIcon.png"
import ConnectDevelopersGif from "../../assets/images/projects/connectDevelopers/connectDevelopersGif.gif"




export const imgContent = {
  InfinityWay:{
    icon: InfinityWayIcon,
    image: InfinityWayImage,
    gif:InfinityWayGif
  },
  blockBraker:{
    icon: blockBrakerIcon,
    image: blockBrakerGameImage,
    gif:blockBrakerGif
  },
  Pong:{
    icon: PongIcon,
    image: PongImage,
    gif:PongGif
  },
  FiftBird:{
    icon: FifbirdIcon,
    image: FifbirdImage,
    gif:FifbirdGif
  },
  ZeldaProject:{
    icon: ProjectZeldaIcon,
    image: ProjectZeldaImage,
    gif:ProjectZeldaGif
  },
	LandingPageDogAdventure:{
      icon: LandingPageDogAdventureIcon,
		image: LandingPageDogAdventureImage,
		gif:LandingPageDogAdventureGif
	},

  RobotClaw:{
    icon: RobotClawIcon,
    image: RobotClawImage,
    gif:RobotClawGif
  },
  EmissionCO2:{
    icon: EmissionCO2Icon,
    image: EmissionCO2Image,
    gif:EmissionCO2Gif
  },
  connectDevelopers:{
    icon: ConnectDevelopersIcon,
    image: ConnectDevelopersImage,
    gif:ConnectDevelopersGif
  },
}